import { useRef, useEffect, DependencyList } from 'react';

export function useTrackedEffect(
  callback: (changedDeps: boolean[], initialRender: boolean, previousDeps: DependencyList) => void,
  dependencies: DependencyList
): void {
  const isFirstRender = useRef(true);
  const prevDeps = useRef(dependencies);

  useEffect(() => {
    const changedDeps = dependencies.map((dep, i) => {
      return dep !== prevDeps.current[i];
    });

    const olderDeps: DependencyList = prevDeps.current;
    prevDeps.current = dependencies;

    callback(changedDeps, isFirstRender.current, olderDeps);

    if (isFirstRender.current) isFirstRender.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
